export default "__VITE_ASSET__CQuNIc41__"